import React from "react"
import PropTypes from "prop-types"
import { Bounce, toast } from "react-toastify"
import CustomButton from "../OnboardingComponents/CustomButton"
import { ICONS } from "../../constants/icons"

/**
 * Shared admin listing “Export Log” control (matches /admin/members).
 * Pass `onClick` once the listing export API is connected.
 */
const ExportLogButton = ({
  entityLabel = "listing",
  className = "",
  onClick,
  loading = false,
  disabled = false,
}) => {
  const handleExport = () => {
    if (typeof onClick === "function") {
      onClick()
      return
    }
    toast.info(
      `Export will be available once the ${entityLabel} API is connected.`,
      { transition: Bounce },
    )
  }

  return (
    <CustomButton
      variant="transparent"
      size="md"
      type="button"
      className={className}
      trailingIconSrc={ICONS.adminDocumentDownload}
      trailingIconAlt=""
      onClick={handleExport}
      loading={loading}
      disabled={disabled || loading}
    >
      Export Log
    </CustomButton>
  )
}

ExportLogButton.propTypes = {
  entityLabel: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
}

ExportLogButton.defaultProps = {
  entityLabel: "listing",
  className: "",
  onClick: undefined,
  loading: false,
  disabled: false,
}

export default ExportLogButton
